<div class="sidebar-backdrop" [class.visible]="isExpanded()" (skkClick)="toggle()"></div>

<div class="sidebar" [class.expanded]="isExpanded()">
  <div class="sidebar-body">
    <div class="sidebar-header">
      <img
        class="sidebar-logo-icon"
        ngSrc="favicon.svg"
        width="32"
        height="32"
        alt="logo"
        [routerLink]="menuItems()[0]?.link ?? '/'"
      />
      <img
        class="sidebar-logo"
        ngSrc="sklepnik-logo.svg"
        width="140"
        height="40"
        alt="logo"
        [routerLink]="menuItems()[0]?.link ?? '/'"
        priority
      />
    </div>
    @if (context() === 'portal') {
      <div class="sidebar-portal-tag" i18n="@@sidebar.portalTag">Customer portal</div>
    }
    <div class="sidebar-items">
      @for (item of menuItems(); track item.name) {
        @if (item.locked) {
          <div
            class="sidebar-item sidebar-item--locked"
            tabindex="0"
            role="button"
            (click)="onLockedModuleClick(item)"
            (keydown.enter)="onLockedModuleClick(item)"
          >
            <i-lucide [img]="item.icon"></i-lucide>
            <a>{{ item.name }}</a>
            @if (item.module) {
              <span [class]="'skk__badge skk__badge--' + planBadgeVariant(item.module)">
                {{ planLabel(item.module) }}
              </span>
            }
          </div>
        } @else {
          <div
            class="sidebar-item"
            [routerLink]="item.link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: !!item.exact }"
          >
            <i-lucide [img]="item.icon"></i-lucide>
            <a>{{ item.name }}</a>
            @if (item.count) {
              <span class="skk__badge skk__badge--blue sidebar-item__count">{{ item.count }}</span>
            }
          </div>
        }
      }
    </div>

    <div class="sidebar-footer">
      <a
        class="sidebar-item sidebar-item--help"
        [href]="helpUrl"
        target="_blank"
        rel="noopener noreferrer"
        i18n-aria-label="@@sidebar.menu.helpAria"
        aria-label="Knowledge base (opens in a new tab)"
      >
        <i-lucide [img]="CircleHelp"></i-lucide>
        <span i18n="@@sidebar.menu.help">Knowledge base</span>
      </a>

      <a
        class="btn btn--primary btn--outline sidebar-consult"
        [href]="consultationUrl"
        target="_blank"
        rel="noopener noreferrer"
        i18n-aria-label="@@sidebar.menu.consultationAria"
        aria-label="Consultation (opens in a new tab)"
        i18n="@@sidebar.menu.consultation"
      >
        Consultation
      </a>
    </div>
  </div>

  <button
    class="sidebar-expand-toggle"
    type="button"
    (click)="toggle()"
    i18n-aria-label="@@sidebar.toggleAriaLabel"
    aria-label="Toggle menu"
  >
    <i-lucide [img]="CircleChevronRight" [size]="24"></i-lucide>
  </button>
</div>
